// Runtime config. Production builds once, so GET /config.json (served by the API) overrides
// the build-time VITE_* values when present.
export type AuthMode = 'cognito' | 'dev';
export type AppConfig = {
  authMode: AuthMode;
  devUser: string;
  cognitoRegion: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  /** Admin → Operations embeds this (API: OPS_DASHBOARD_URL). */
  opsDashboardUrl: string;
};

const fromEnv = (): AppConfig => ({
  authMode: import.meta.env.VITE_AUTH_MODE === 'cognito' ? 'cognito' : 'dev',
  devUser: import.meta.env.VITE_DEV_USER || 'ryan@vertekal.com',
  cognitoRegion: import.meta.env.VITE_COGNITO_REGION || '',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  opsDashboardUrl: import.meta.env.VITE_OPS_DASHBOARD_URL || 'http://spark-sam.tailb1b71a.ts.net:4400/#prod/overview',
});

let current: AppConfig = fromEnv();
let loading: Promise<AppConfig> | null = null;

export function loadConfig(): Promise<AppConfig> {
  if (loading) return loading;
  loading = (async () => {
    try {
      const res = await fetch('/config.json', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      const type = res.headers.get('content-type') ?? '';
      if (res.ok && type.includes('json')) {
        const raw = (await res.json()) as Partial<AppConfig>;
        current = {
          ...current,
          ...(raw.authMode === 'cognito' || raw.authMode === 'dev' ? { authMode: raw.authMode } : {}),
          ...(raw.cognitoRegion ? { cognitoRegion: raw.cognitoRegion } : {}),
          ...(raw.cognitoUserPoolId ? { cognitoUserPoolId: raw.cognitoUserPoolId } : {}),
          ...(raw.cognitoClientId ? { cognitoClientId: raw.cognitoClientId } : {}),
          ...(raw.devUser ? { devUser: raw.devUser } : {}),
          ...(raw.opsDashboardUrl ? { opsDashboardUrl: raw.opsDashboardUrl } : {}),
        };
      }
    } catch {
      // No runtime config: keep build-time values.
    }
    return current;
  })();
  return loading;
}

export const config = (): AppConfig => current;
